module.exports = __webpack_public_path__ + "static/img/sjzm_03.ce755e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sjzm_03.jpg
// module id = A2EF
// module chunks = 1